import {
  FETCH_USER_CREDITS_REQUEST,
  FETCH_USER_CREDITS_SUCCESS,
  FETCH_USER_CREDITS_FAILURE,
} from '../../constants/ActionTypes';

const credits = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_USER_CREDITS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_USER_CREDITS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_USER_CREDITS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default credits;
